import { render, staticRenderFns } from "./VideoGrid.vue?vue&type=template&id=9635a0e8&"
import script from "./VideoGrid.vue?vue&type=script&lang=js&"
export * from "./VideoGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsEmbed: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsEmbed.vue').default})
